import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/withdraw_applications',
  component: Management,
  redirect: '/withdraw_applications/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/withdraw_applications/List'),
      meta: {
        auth: Auth.listWithdrawApplications
      },
      redirect: 'list/all',
      children: [
        {
          path: 'all',
          component: () => import('@/views/withdraw_applications/ListTable'),
          meta: {
            auth: Auth.listWithdrawApplications,
            tabName: 'all'
          }
        },
        {
          path: 'pending',
          component: () => import('@/views/withdraw_applications/ListTable'),
          meta: {
            auth: Auth.listWithdrawApplications,
            tabName: 'pending'
          }
        },
        {
          path: 'passed',
          component: () => import('@/views/withdraw_applications/ListTable'),
          meta: {
            auth: Auth.listWithdrawApplications,
            tabName: 'passed'
          }
        },
        {
          path: 'failed',
          component: () => import('@/views/withdraw_applications/ListTable'),
          meta: {
            auth: Auth.listWithdrawApplications,
            tabName: 'failed'
          }
        },
        {
          path: 'transferred',
          component: () => import('@/views/withdraw_applications/ListTable'),
          meta: {
            auth: Auth.listWithdrawApplications,
            tabName: 'transferred'
          }
        },
        {
          path: 'rejected',
          component: () => import('@/views/withdraw_applications/ListTable'),
          meta: {
            auth: Auth.listWithdrawApplications,
            tabName: 'rejected'
          }
        }
      ]
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/withdraw_applications/DetailLayout'),
      meta: {
        auth: Auth.showWithdrawApplication
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/withdraw_applications/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showWithdrawApplication
          }
        }
      ]
    }
  ]
}
